<template>
  <div class="alumn-list">
    <div v-if="list.length > 0">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <alumnItem :alumn="alumn" v-for="(alumn, index) in list" :key="index" />
      </van-list>
    </div>
    <van-empty v-else description="暂无专辑"></van-empty>
  </div>
</template>

<script>
import alumnItem from './alumnItem.vue'
import {getAlumnList} from '@/api'
export default {
  components: {
    alumnItem
  },
  data() {
    return {
      list: [],
      params: {
        pageNo: 1,
        pageSize: 20,
        specialsName: ''
      },
      maxPageSize: 1,
      finished: false,
      loading: false
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    onLoad() {
      if (this.params.pageNo >= this.maxPageSize) {
        this.finished = true
        return
      }
      this.params.pageNo += 1
      this.loading = true
      this.getInfo()
    },
    getInfo() {
      getAlumnList(this.params).then(res => {
        if (res.code === 0) {
          this.list = [...this.list, ...res.data]
          this.maxPageSize = Math.ceil(res.totalDatas / this.params.pageSize)
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alumn-list {
  padding: 12px 16px;
  min-height: 100vh;
  background: #f4f6f9;
}
</style>
